import { FEATURES_LIST } from '@/config/constants';
import FeatureCard from './FeatureCard';

export default function FeaturesSection() {
  return (
    <section id="features" className="section-padding bg-white dark:bg-secondary-900">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-secondary-900 dark:text-white mb-4">
            Everything You Need for Secure Clinical Documentation
          </h2>
          <p className="text-lg text-secondary-600 dark:text-secondary-400">
            Built specifically for mental health practitioners in Australia, with security and
            compliance at the core.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {FEATURES_LIST.map((feature) => (
            <FeatureCard key={feature.title} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
}

